<template>
  <div>
    <div class="py-20 bg-white">
      <div class="px-4 mx-auto text-center max-w-7xl sm:px-6 lg:px-8">
        <h2
          class="text-3xl font-extrabold tracking-tight text-yellow-500 sm:text-4xl md:text-5xl xl:text-6xl"
        >
          coming soon
        </h2>
        <p
          class="max-w-md mx-auto mt-3 text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl"
        >
          This page is under development.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Commingsoon"
};
</script>
